'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loadImage = require('./loadImage');

var _dataURIToBlob = require('../file/dataURIToBlob');

var _dataURIToBlob2 = _interopRequireDefault(_dataURIToBlob);

var _mimeConstants = require('../../../../common/media/mimeConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PORTRAIT_ORIENTATIONS = [5, 6, 7, 8];

// Constants
// Utils


var isPortraitOrientation = function isPortraitOrientation(orientation) {
    return PORTRAIT_ORIENTATIONS.indexOf(orientation) !== -1;
};

var buildTransformationArray = function buildTransformationArray(width, height) {
    return [function (ctx) {
        return ctx;
    }, function (ctx) {
        return ctx;
    }, function (ctx) {
        return ctx.transform(-1, 0, 0, 1, width, 0);
    }, function (ctx) {
        return ctx.transform(-1, 0, 0, -1, width, height);
    }, function (ctx) {
        return ctx.transform(1, 0, 0, -1, 0, height);
    }, function (ctx) {
        return ctx.transform(0, 1, 1, 0, 0, 0);
    }, function (ctx) {
        return ctx.transform(0, 1, -1, 0, height, 0);
    }, function (ctx) {
        return ctx.transform(0, -1, -1, 0, height, width);
    }, function (ctx) {
        return ctx.transform(0, -1, 1, 0, 0, width);
    }];
};

exports.default = function (_ref) {
    var srcOrientation = _ref.srcOrientation,
        imageDataUri = _ref.imageDataUri;
    return (0, _loadImage.loadImageFromDataUrl)(imageDataUri).then(function (imageLoadEvent) {
        var img = imageLoadEvent.target;
        var width = img.width;
        var height = img.height;

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        var isPortrait = isPortraitOrientation(srcOrientation);
        canvas.width = isPortrait ? height : width;
        canvas.height = isPortrait ? width : height;

        // transform context before drawing image
        var transformationArray = buildTransformationArray(width, height);
        var transformationFn = transformationArray[srcOrientation] || transformationArray[0];
        transformationFn(ctx);

        // draw image
        ctx.drawImage(img, 0, 0);

        var rotatedImageBase64 = canvas.toDataURL(_mimeConstants.MIME_TYPES.JPEG);
        var rotatedImageFile = (0, _dataURIToBlob2.default)(rotatedImageBase64);

        return { file: rotatedImageFile, imageDataUri: rotatedImageBase64 };
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/image/jpegExifOrientationTransformer.js
// module id = 2138
// module chunks = 0